module.exports = __webpack_public_path__ + "img/feature_b07.8147a0a6.svg";